<template>
  <b-sidebar id="add-new-survey-type-sidebar" :visible="isAddNewSidebarActive" bg-variant="white"
    sidebar-class="sidebar-lg" shadow backdrop no-header right @hidden="resetForm"
    @change="(val) => $emit('update:is-add-new-sidebar-active', val)">
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ $t('surveyType.create') }}
        </h5>
        <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="hide" />
      </div>

      <!-- BODY -->
      <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
        <!-- Form -->
        <b-form class="p-2" @submit.prevent="handleSubmit(onSubmit)" @reset.prevent="resetForm">

          <!-- Title -->
          <validation-provider #default="validationContext" name="Survey Type Title" rules="required">
            <b-form-group :label="$t('surveyType.title')" label-for="survey-type-title">
              <b-form-input id="survey-type-title" v-model="surveyTypeData.title" autofocus
                :state="getValidationState(validationContext)" trim :placeholder="$t('surveyType.placeholder.title')" />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Type Key -->
          <validation-provider #default="validationContext" name="Survey Type Key" rules="required">
            <b-form-group :label="$t('surveyType.key')" label-for="survey-type-key">
              <b-form-input id="survey-type-key" v-model="surveyTypeData.typekey" 
                :state="getValidationState(validationContext)" placeholder="employee-satisfaction" trim />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Description -->
          <b-form-group :label="$t('surveyType.description')" label-for="survey-type-description">
            <b-form-textarea id="survey-type-description" v-model="surveyTypeData.description" 
              :placeholder="$t('surveyType.placeholder.description')" rows="3" />
          </b-form-group>

          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mr-2" type="submit">
              {{ $t("Add") }}
            </b-button>
            <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" type="button" variant="outline-secondary"
              @click="hide">
              {{ $t("Cancel") }}
            </b-button>
          </div>

        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormTextarea, BFormInvalidFeedback, BButton,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { ref } from '@vue/composition-api'
import { required } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import store from '@/store'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BFormInvalidFeedback,
    BButton,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddNewSidebarActive',
    event: 'update:is-add-new-sidebar-active',
  },
  props: {
    isAddNewSidebarActive: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      required,
    }
  },
  setup(props, { emit }) {
    const blankSurveyTypeData = {
      title: '',
      typekey: '',
      description: '',
    }

    const surveyTypeData = ref(JSON.parse(JSON.stringify(blankSurveyTypeData)))
    const resetSurveyTypeData = () => {
      surveyTypeData.value = JSON.parse(JSON.stringify(blankSurveyTypeData))
    }

    const onSubmit = () => {
      store.dispatch('app-survey-types/addSurveyType', surveyTypeData.value)
        .then(() => {
          emit('refetch-data')
          emit('new-record-created')
          emit('update:is-add-new-sidebar-active', false)
        })
    }

    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetSurveyTypeData)

    return {
      surveyTypeData,
      onSubmit,
      refFormObserver,
      getValidationState,
      resetForm,
    }
  },
}
</script>

<style lang="scss">
#add-new-survey-type-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
